/*
 * @fileTile: 
 * @Description: 
 * @Autor: zsf
 * @Date: 2024-04-02 09:24:45
 * @LastEditTime: 2024-08-16 08:47:09
 */
const location = window.location
let NODE_ENV
switch (location.hostname) {
  case 'tbwldev.tianbang.com':
    NODE_ENV = 'dev'
    break
  case 'tbwltest.tianbang.com':
    NODE_ENV = 'test'
    break
  case 'tbwl.tianbang.com':
    NODE_ENV = 'prod'
    break
  default:
    NODE_ENV = 'localhost'
    break
}
export default NODE_ENV



// WEBPACK FOOTER //
// ./src/utils/env.js